import { render, staticRenderFns } from "./LandscapeTip.vue?vue&type=template&id=166a6d56&scoped=true&"
import script from "./LandscapeTip.vue?vue&type=script&lang=js&"
export * from "./LandscapeTip.vue?vue&type=script&lang=js&"
import style0 from "./LandscapeTip.vue?vue&type=style&index=0&id=166a6d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166a6d56",
  null
  
)

export default component.exports